import {apiUrl, dateFormat, alert, isEmptyObj} from '../helper'
import $ from 'jquery'
import moment from 'moment'

export default {
  data () {
    return {
      // suggestNum: -1,
      // queue: [],
      // suggestagain: true,
      // suggestions: [],
      // oldsuggestValue: '',
      loading: false,
      searched: 0,
      showTypAll:true,
      sts: 0,
      advsearch: 0,
      cond_type: {'type': '公告类型', 'labels': '公告标签', 'plate': '板块类型', 'layer': '挂牌公司', 'region': '地区类型', 'securityCompany': '主办劵商', 'industry': '行业类型', 'industrysecond': '行业子类', 'qaType': '问答类型'},
      // conditions: {   // 条件
      //   'type': {},
      //   'qaType': {},
      //   'plate': {},
      //   'layer': {},
      //   'region': {},
      //   'industry': {},
      //   'industrysecond': {},   // 行业子类
      //   'securityCompany': {},
      //   'labels': {}
      // },
      memory: {},
      // pageshowConditions: {
      //   'type': {},
      //   'qaType': {},
      //   'plate': {},
      //   'region': {},
      //   'securityCompany': {},
      //   'industry': {
      //     'A农，林，牧，渔业': [],
      //     'B采矿业': [],
      //     'C制造业': [],
      //     'D电力、热力、燃气及水生产和供应业': [],
      //     'E建筑业': [],
      //     'F批发和零售业': [], 'G交通运输、仓储和邮政业': [], 'H住宿和餐饮业': [], 'I信息传输、软件和信息技术服务业': [], 'J金融业': [], 'K房地产业': [], 'L租赁和商务服务业': [], 'M科学研究和技术服务业': [], 'N水利、环境和公共设施管理业': [], 'O居民服务、修理和其他服务业': [], 'P教育': [], 'Q卫生和社会工作': [], 'R文化、体育和娱乐业': []},
      //   'plate': {'SZZB': '', 'SZZXB': '', 'SZCYB': '', 'SHZB': '', '挂牌公司': [], 'N3BTS': ''},
      //   'labels': {}
      // },
      // anoConditions: {
      //   'type': {},
      //   'qaType': {},
      //   'plate': {},
      //   'layer': {},
      //   'region': {},
      //   'industry': {},
      //   'industrysecond': {},
      //   'securityCompany': {},
      //   'labels': {}
      // },
      // showType: true,    // 公告类型
      // showQaType: true,   // 问题类型
      // showPlate: true,    // 板块类型
      // showRegion: true,   // 地区类型
      // showSecurityCompany: true,  // 主办券商
      // showIndustry: true,   // 行业类型
      stype: 1,          // tag type, 标签类型， 如：A股、新三板、问题库
      ttype: 0,          // title type, 标题类型
      ttype_name: '全部',
      ttype_dropdown: false,
      keywords: '',
      companyCode: '',  // 公司证券代码
      publishDate: '',  // 发布日期
      datetype: 0,  // 发布日期
      datetype_name: '',   // 筛选日期范围名称
      // startdate: '',
      // enddate: '',
      ttypeMap: {0: '全部', 1: '标题', 2: '章节标题', 3: '正文', 4: '问题', 5: '答案', 6: '图片'},  // title标签类型
      optypeMap: {1: '包含全部关键词', 2: '包含任意关键词', 3: '不含全部关键词'},
      keywords_condition: [{     // 关键词条件
        val: '',
        ttype: 0,
        ttname: '全部',
        optype: 1,
        opname: '包含全部关键词'
      }],
      typeAll: [],    // 元数据，所有类型
      types: [],  // 类型
      qaTypes: [],  // 问题类型
      plateAll: {},  // 所有板块
      plates: [],  // 板块类型
      regions: [],  // 地区
      securityCompany: [],   // 主板券商
      industry: [],  // 行业
      showConditionFlag: '',
      // showChildFlag: {'plate': false, 'industry': false},
      showSubTitle: true,
      // hotKeywords: [],  // 关键词排行
      showModal: false,
      tagname: '',
      // tags: [],   // 标签列表
      parseVer: '',
      idxname: '',
      // showInd: false,
      // showPla: false,
      // havelabels: false,
      pholder: '002330',   // 证券代码
      // showMylabels: 1,   // 切换我的标签和已选条件
      // suggTyp: {1: 'a', 2: 'n3b', 6: 'h'},
      showDropdownMenu:　'',    // 控制下拉框的显示与收起
      ai: 0,
      smartEngine: {
        open: false,
        companyInfo: {}
      },
      condition_field: {
        'havelabels': false,
        'showPla': false,
        'showInd': false,
        'companyCode': ''
      },
      reportDataList:[],
      currStypObj: {
        "1": {},
        "2": {},
        "3": {},
        "4": {},
        "5": {},
        "6": {},
        "7": {},
        "8": {},
        "9": {},
        "10": {},
        "11": {},
        "12": {},
        "13": {},
        "14": {},
        "15": {},
        "17":{},
        "100":{}
      },
      stypesArr:[],
      stypesTotal: {'1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '10': 0, '11': 0, '12': 0, '13': 0, '14': 0},
      stypesMap: {'1': 'complex_agu', '2': 'complex_n3b', '3': 'complex_bond', '4': 'complex_knowledge', '5': 'complex_qa', '6': 'complex_hk', '10': 'complex_abs', '11': 'complex_yb', '12': 'complex_news', '13': 'complex_reportdata', '14': 'complex_data'},
      complex_stypes: [{'stype': 12, 'name': '新闻'}, {'stype': 4, 'name': '知识库'}, {'stype': 13, 'name': '研报数据'}, {'stype': 11, 'name': '研报'}, {'stype': 14, 'name': '数据'}, {'stype': 1, 'name': 'A股'}, {'stype': 2, 'name': '新三板'}, {'stype': 5, 'name': '问题库'}, {'stype': 6, 'name': '港股'}, {'stype': 3, 'name': '债券'}, {'stype': 10, 'name': 'ABS'}],
      complex_agu: null,
      complex_n3b: null,
      complex_bond: null,
      complex_knowledge: null,
      complex_qa: null,
      complex_hk: null,
      complex_abs: null,
      complex_yb: null,
      complex_news: null,
      complex_reportdata: null,
      complex_data: null,
      tipGoBind: false,      // false-不显示绑定弹框，true-显示绑定弹框
      currentRegtyp: '',      // 是否绑定微信，1-已绑定，4-未绑定
      goBindPageShortLink: '',
      reportDataTotal:null,
      reportDataTotalPage:null
    }
  },
  watch: {
    // 'ttype': function (val, oldVal) {
    //   this.ttype_name = this.ttypeMap[val]
    // },
    'stype': function (val, oldVal) {
      if (val === 1 || val === 5) {
        this.pholder = '002330'
      } else if (val === 2) {
        this.pholder = '835605'
      } else if (val === 6 ) {
        this.pholder = '08072'
      } else {
        this.pholder = ''
      }
    },
    // 'datetype': function (val, oldVal) {
    //   if (val === 1) {
    //     this.datetype_name = '一个月'
    //   }
    //   if (val === 2) {
    //     this.datetype_name = '一个季度'
    //   }
    //   if (val === 3) {
    //     this.datetype_name = '半年'
    //   }
    //   if (val === 4) {
    //     this.datetype_name = '去年'
    //   }
    //   if (val === 5) {
    //     this.datetype_name = '今年'
    //   }
    //   if (val === 6) {
    //     this.datetype_name = '一年'
    //   }
    //   if (val === 7) {
    //     this.datetype_name = '两年'
    //   }
    //   if (val === 8) {
    //     this.datetype_name = '三年'
    //   }
    //   if (val === 9) {
    //     this.datetype_name = '五年'
    //   }
    //   if (val === 10) {
    //     this.datetype_name = '十年'
    //   }
    //   if (val === 98) {
    //     this.datetype_name = '全部'
    //   }
    //   if (val === 99) {
    //     this.datetype_name = '自定义'
    //   }
    // }
  },
  methods: {
     /**
     * 返回两个日期之间的日期数组
     * @param  { string } begin 起始日期
     * @param  { string } end   结束日期
     * @return { array  }       完整日期数组
     */
    getAllDay(begin, end) {
      // console.log(begin)
      // console.log(end)
      Date.prototype.format = function() {
        var s = '';
        var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));
        var day = this.getDate()>=10?this.getDate():('0'+this.getDate());

        s += this.getFullYear() + '-'; // 获取年份。
        s += mouth + "-"; // 获取月份。
        s += day; // 获取日。

        return (s); // 返回日期。
      };

      var allDay = [];
      var ab = begin.split("-");
      var ae = end.split("-");
      var db = new Date();

      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);

      var de = new Date();
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);

      var unixDb = db.getTime();
      var unixDe = de.getTime();
      for (var k = unixDb; k <= unixDe;) {
          allDay.push( (new Date(parseInt(k))).format() );
          k = k + 24 * 60 * 60 * 1000;
      }
      
      return allDay;
    },
    // 打开公司详情页
    goCompanyInfo (code) {
      console.log(code)
      if (JSON.stringify(this.smartEngine.companyInfo) == "{}") {
        this.getCompanyDetail(code)
      }
      this.smartEngine.open = true
    },
    // 获取智能引擎公司详情
    getCompanyDetail (code) {
      let query = {}
      query.code = code
      this.loading = true
      $.ajax({
        url: apiUrl('/V1.0.0/company/detail'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        this.loading = false
        if (response.status === 0) {
          this.smartEngine.companyInfo = response.data
        } else {
          this.loading = false
          console.log(response.description)
        }
      }).fail((response) => {
        this.loading = false
        alert('请求失败')
      })
    },
    setCompanyCode: function (i) {
      let idx = i.indexOf('(')
      this.companyCode = i.substr(0, idx)
      this.companyCode = this.companyCode.trim()
      this.suggestions = []
    },
    /**
     * 添加关键词条件
     */
    addKeywordCondition () {
      if (this.currentRegtyp == 4) {
        this.tipGoBind = true
        return
      }
      this.keywords_condition.push({
        val: '',
        ttype: 0,
        ttname: '全部',
        optype: 1,
        opname: '包含全部关键词'
      })
    },
    /**
     * 切换板块
     * @param  { String } val - 1:A股 2:新三板 3:债券 5:问题库 6:港股 4:知识库 7:法院公告 8:裁判文书 9:政府公告 10:ABS 11:研报 12:新闻 15: 我的文档 100 ： 综合
     */
    changeStype (val) {
      console.log(val)
      // 控制全部筛选类型
      this.showTypAll = true
      // this.currStypObj = null
        // 没绑定，绑定微信
      if (this.currentRegtyp == 4) {
        this.tipGoBind = true
        return
      }
      let oldVal = this.stype
       // english
       if(val == 17){
        console.log('english')
        console.log('val == 17')
        if (!this.checkPrivilege('search/english', '暂无权限english')) {
          return false
        }
      }
      // A股
      if (val == 1) {
        console.log("跳转到A股")
        console.log('val == 1')
        if (!this.checkPrivilege('search/a', '暂无权限A')) {
          return false
        }
        let plateAll = this.plateAll
        let plates = []
        for (let t of plateAll['A']) {
          t.count = 0
          plates.push(t)
        }
        this.plates = plates
        // console.log(this.plates)
        this.types = this.getTypeByCat('A')
        this.showType = true
        this.showQaType = false
        this.showPlate = true
        this.showRegion = true
        this.showSecurityCompany = false
        this.showIndustry = true
        this.showSubTitle = true
        this.showLabels = false
        this.showStage = false
      }
      // 新三板
      if (val == 2) {
        console.log("跳转到新三板")
        if (!this.checkPrivilege('search/n3b', '暂无权限')) {
          return false
        }
        let plateAll = this.plateAll
        let plates = []
        for (let t of plateAll['N3B']) {
          if (!t.count) {
            t.count = 0
          }
          plates.push(t)
        }
        this.plates = plates
        // console.log(this.plates)
        this.types = this.getTypeByCat('N3B')
        this.showType = true
        this.showQaType = false
        this.showPlate = true
        this.showRegion = true
        this.showSecurityCompany = true
        this.showIndustry = true
        this.showSubTitle = true
        this.showLabels = false
        this.showStage = false
      }
      // 债券
      if (val == 3) {
        console.log("跳转到债券")
        if (!this.checkPrivilege('search/bond', '暂无权限')) {
          return false
        }
        this.types = this.getTypeByCat('ChinaBond')
        this.showType = true
        this.showQaType = false
        this.showPlate = false
        this.showRegion = true
        this.showSecurityCompany = false
        this.showIndustry = false
        this.showSubTitle = true
        this.showLabels = false
        this.showStage = false
      }
      // 问题库
      if (val == 5) {
        console.log("跳转到问题库")
        if (!this.checkPrivilege('search/qa', '暂无权限')) {
          return false
        }
        this.showType = false
        this.showQaType = true
        this.showPlate = false
        this.showRegion = false
        this.showSecurityCompany = false
        this.showIndustry = true
        this.showSubTitle = false
        this.showLabels = false
        this.showStage = false
        if (this.ttype === 2) {
          this.ttype = 0
        }
        for (let k of this.keywords_condition) {
          if (k.ttype === 2) {
            this.changeKyTtype(k, 0, '全部')
          }
        }
      } else {
        if (this.ttype === 4 || this.ttype === 5) {
          this.ttype = 0
        }
        for (let k of this.keywords_condition) {
          if (k.ttype === 4 || k.ttype === 5) {
            this.changeKyTtype(k, 0, '全部')
          }
        }
      }

      // 港股
      if (val === 6) {
        console.log("跳转到港股")
        if (!this.checkPrivilege('search/h', '暂无权限')) {
          return false
        }
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
      }
      // 研报
      if (val === 11) {
        if (!this.checkPrivilege('search/report', '暂无权限')) {
          return false
        }
        console.log("跳转到研报")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Report')
        this.showType = true
        this.showQaType = false
        this.showPlate = false
        this.showRegion = false
        this.showSecurityCompany = false
        this.showIndustry = false
        this.showSubTitle = true
        this.showLabels = false
        this.showStage = false
      }
      if(val == 17){
        if (!this.checkPrivilege('search/english', '暂无权限')) {
          return false
        }
        console.log("跳转到 english")
        this.showType = true
        this.showQaType = false
        this.showPlate = false
        this.showRegion = false
        this.showSecurityCompany = false
        this.showIndustry = false
        this.showSubTitle = true
        this.showLabels = false
        this.showStage = false
      }
      
    // 新加模块

      /* 
      showtype：公告类型    showQaType：问题类型    showPlate：板块类型   showRegion：地区类型
      showSecurityCompany：主板券商   showIndustry：行业分类    showSubTitle：章节标题
      showLabels：
      */
      // 知识库
      if (val === 4) {
        if (!this.checkPrivilege('search/weixin', '暂无权限')) {
          return false
        }
        console.log("知识库")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Weixin')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      // 法律公告
      if (val === 7) {
        if (!this.checkPrivilege('search/lawnotice', '暂无权限')) {
          return false
        }
        console.log("跳转到法律公告")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Lawnotice')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      // 裁判文书
      if (val === 8) {
        if (!this.checkPrivilege('search/legal', '暂无权限')) {
          return false
        }
        console.log("跳转到裁判文书")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Legal')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      // 政府公告
      if (val === 9) {
        if (!this.checkPrivilege('search/gov', '暂无权限')) {
          return false
        }
        console.log("跳转到政府公告")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Gov')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      if (val === 10) {
        if (!this.checkPrivilege('search/abs', '暂无权限')) {
          return false
        }
        console.log("跳转到ABS")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Abs')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      // 新闻
      if (val === 12) {
        if (!this.checkPrivilege('search/news', '暂无权限')) {
          return false
        }
        console.log("跳转到新闻")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        console.log(111111111111111)
        this.types = this.getTypeByCat('News')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      // 我的文档
      if (val === 15) {
        if (!this.checkPrivilege('search/docs', '暂无权限')) {
          return false
        }
        console.log("跳转到我的文档")
        let arr = [4, 5]
        this.tabChangeCtrl(arr)
        this.types = this.getTypeByCat('Docs')
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      if (val === 100) {
        console.log("综合搜索")
        let arr = [2, 4, 5, 6, 7, 8, 9]
        this.tabChangeCtrl(arr)
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      if (val === 13) {
        console.log("研报数据")
        let arr = [2, 4, 5, 6, 7, 8, 9]
        this.tabChangeCtrl(arr)
        this.showTypAll = false
        this.showLabels = false
        this.showStage = false
        this.showSubTitle = false
      }
      
   


    // 新加信息模块
      this.stype = val
      // alert(oldVal)
      if(val != 100){
        for (let item in this.condition_field) {
          this.currStypObj[oldVal][item] = this[item]
        }
  
        this.currStypObj[oldVal]['conditions'] =  this.conditions
        this.conditions = {'type': {},'qaType': {},'plate': {},'layer': {},'region': {},'industry': {},'industrysecond': {},'securityCompany': {},'labels': {},'stage': {}}
  
        for (let i of this.industry) {
          i.count = 0
        }
  
        for (let j of this.plates) {
          j.count = 0
        }
  
        console.log('node node node');
        console.log(this.currStypObj);
        console.log("Obejct.keys 里面参数")
        console.log(this.currStypObj)
        console.log(this.currStypObj[val]);
        // console.log(this.plates)
        if (Object.keys(this.currStypObj[val]).length > 0) {
          for (let item in this.condition_field) {
            this[item] = this.currStypObj[val][item]
          }
          console.log('11-11');
          this.conditions = this.currStypObj[val]['conditions']
          console.log('11-22');
          for (let k of this.industry) {
            this.setNum('industrysecond', k)
          }
          console.log('11-33');
          for (let t of this.plates) {
            this.setNum('layer', t)
          }
          console.log('11-44');
        } else {
          console.log(1111);
          for (let item in this.condition_field) {
            this[item] = this.condition_field[item]
          }
          this.conditions = {'type': {},'qaType': {},'plate': {},'layer': {},'region': {},'industry': {},'industrysecond': {},'securityCompany': {},'labels': {},'stage': {}}
          console.log(122222);
        }
  
        console.log('conditions');
        console.log(this.conditions)
        this.addToShow()
        if (this.tagclicked) {
          this.searchByTagAfter(this.tagdata)
          this.tagclicked = false
        }
      }
    },
    // tab 切换 如果出现没有的下拉菜单项，则重置
    tabChangeCtrl: function (arr) {
      if (arr.indexOf(this.ttype) >= 0) {
        this.ttype = 0
      }
      for (let k of this.keywords_condition) {
        if (arr.indexOf(k.ttype) >= 0) {
          this.changeKyTtype(k, 0, '全部')
        }
      }
    },
    /**
     * 返回A股/新三板公告详情链接
     * @param  { Object } item  搜索结果child数组项
     * @return { String }       详情页链接
     */
    viewUrl: function (item) {
      if (item.viewtype === 1) {
        let tcode = ''
        if (item.pid) {
          return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid
        } else {
          return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid
        }
      }
      if (item.viewtype === 2) {
        return item.viewurl
      }
      if (item.viewtype === 3) {
        return item.downloadurl
      }
    },
    /**
     * 返回问题库详情页链接
     * @param  { Object } item  搜索结果child数组项
     * @return { String }       详情页链接
     */
    qaViewUrl (item) {
      if (item.viewtype === 1) {
        let tcode = ''
        return '/#!/qaview/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid
      }
      if (item.viewtype === 2) {
        return item.viewurl
      }
      if (item.viewtype === 3) {
        return item.downloadurl
      }
    },
    /**
     * 获取元数据
     */
    getMeta () {
      $.ajax({
        url: apiUrl('/V1.0.0/notice/meta'),
        method: 'post',
        async: false,
        dataType: 'json'
      }).done((response) => {
        if (response.status === 0) {
          this.typeAll = response.types   // ----------------------- 类型
          let plateAll = response.plates  // 板块类型
          for (let t in plateAll) {
            for (let d of plateAll[t]) {
              d.showChild = false  // 不展示子级
              d.count = 0
            }
          }
          this.plateAll = plateAll
          let region = response.region  // ------------------------- 地区类型
          for (let k in region) {
            let t = region[k]
            t.count = 0   // 数目
            region[k] = t
          }
          this.regions = region
          let industry = response.industry  // --------------------- 行业类型
          for (let k in industry) {
            let t = industry[k]
            t.count = 0
            t.showChild = false
            industry[k] = t
          }
          this.industry = industry
          let securityCompany = response.securityCompany   // ------ 行业子类
          for (let k in securityCompany) {
            let t = securityCompany[k]
            t.count = 0
            securityCompany[k] = t
          }
          this.securityCompany = securityCompany  // --------------- 主办券商
          this.qaTypes = response.qaTypes   // --------------------- 问题类型
          this.changeStype(this.stype)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    hideCondition () {
      this.showConditionFlag = ''
      this.showSort = false
      this.ttype_dropdown = false
    },
    /**
     * 设置标题左边距
     * @param  { String } code 标题id值
     */
    indentChild (code) {
      let len = code.split('.').length - 2
      // return {'padding-left': len * 10 + 'px'}
    },
    /**
     * 解析Url参数，从url中解析出查询条件
     * @param query
     */
    parseUrlQuery (query) {     // 解析查询参数
      if (query.hasOwnProperty('conditions')) {   // 有conditions属性
        let conditions = query['conditions'].split(',')
        for (let c of conditions) {
          let carr = c.split('_')
          if (carr.length === 3) {
            let type = carr[0]
            let code = carr[1]
            let name = carr[2]
            let tmp = {}
            tmp[code] = name
            this.conditions[type] = Object.assign({}, this.conditions[type], tmp)
          }
        }
      } else {    // 无conditions属性
        this.conditions = {
          'type': {},
          'qaType': {},
          'plate': {},
          'layer': {},
          'region': {},
          'industry': {},
          'industrysecond': {},
          'securityCompany': {},
          'labels': {}
        }
      }
      if (query.hasOwnProperty('industry')) {   // 有行业类型
        let industry = query['industry'].split(',')
        for (let c of industry) {
          let arr = c.split('_')
          if (arr.length === 2) {
            let idx = arr[0]
            let count = arr[1]
            this.industry[idx].count = parseInt(count)
          }
        }
      } else {
        for (let i of this.industry) {
          i.count = 0
        }
      }
      if (query.hasOwnProperty('keywords_condition')) {   // 有关键词条件
        let conditions = query['keywords_condition'].split(',')
        let keywordCondition = []
        for (let c of conditions) {
          let carr = c.split('_')
          let val = carr[0]
          let ttype = carr[1]
          let optype = carr[2]
          let ttname = this.ttypeMap[ttype]
          let opname = this.optypeMap[optype]
          keywordCondition.push({
            val: val,
            ttype: parseInt(ttype),
            ttname: ttname,
            optype: parseInt(optype),
            opname: opname
          })
        }
        this.keywords_condition = keywordCondition
      } else {
        this.keywords_condition = [{
          val: '',
          ttype: 0,
          ttname: '全部',
          optype: 1,
          opname: '包含全部关键词'
        }]
      }
      // 板块类型
      if (this.plates[0].child && this.plates[0].child.length > 0 && query['plate']) {
        this.plateAll['N3B'][0].count = parseInt(query['plate'])
        this.plates[0].count = parseInt(query['plate'])
      } else {
        this.plateAll['N3B'][0].count = 0
        this.plates[0].count = 0
      }
      this.stype = parseInt(query['stype']) || 1
      this.ttype = parseInt(query['ttype']) || 0
      this.keywords = query['keywords'] || ''
      this.companyCode = query['companyCode'] || ''
      this.datetype = parseInt(query['datetype']) || 9
      this.startdate = query['startdate'] || ''
      this.enddate = query['enddate'] || ''
      if (!this.startdate && !this.enddate) {
        this.changeDateType(this.datetype)
      }
      this.perPage = parseInt(query['perPage']) || 10
      this.page = parseInt(query['page']) || 1
      this.sort = parseInt(query['sort']) || 1
      this.onlyTitle = query['onlyTitle'] || 0
      this.parseVer = query['parseVer'] || ''
      this.idxname = query['idxname'] || ''
        // this.ai = parseInt(query['ai']) || 0
    },
    showCondition (type) {
      if (this.currentRegtyp == 4) {
        this.tipGoBind = true;
        return
      }
        this.showConditionFlag = type
    },
    /**
     * 分页时调用：设置url查询字符串
     * @returns {{}}
     */
    genUrlQuery () {
      let query = {}
      let conditions = []
      let industry = []
      let anoConditions = []
      if (this.plates[0].count > 0) {   // 板块类型
        let plate = this.plates[0].count
        query['plate'] = plate
      }
      for (let item in this.industry) {   // 行业类型
        if (this.industry[item].count !== 0) {
          industry.push(item + '_' + this.industry[item].count)
        }
      }
      query['industry'] = industry.join(',')
      for (let type in this.conditions) {   // 条件
        for (let code in this.conditions[type]) {
          conditions.push(type + '_' + code + '_' + this.conditions[type][code])
        }
      }
      query['conditions'] = conditions.join(',')
      let keywordCondition = []
      for (let i of this.keywords_condition) {   // 关键词条件
        i.val = this.delPunctuation(i.val)
        keywordCondition.push(i.val + '_' + i.ttype + '_' + i.optype)
      }
      query['keywords_condition'] = keywordCondition.join(',')
      query['stype'] = this.stype
      query['ttype'] = this.ttype
      query['keywords'] = this.keywords
      query['companyCode'] = this.companyCode
      query['datetype'] = this.datetype
      query['startdate'] = this.startdate
      query['enddate'] = this.enddate
      query['perPage'] = this.perPage
      query['page'] = this.page
      query['sort'] = this.sort
      query['onlyTitle'] = this.onlyTitle
      query['sts'] = new Date().getTime()
      query['parseVer'] = this.parseVer
      query['idxname'] = this.idxname
      query['ai'] = this.ai
      // query['sid'] = this.sid
      query['sid'] = this.params.sid
      query['ruid'] = this.params.uidUrl
      return query
    },
    /**
     * 获取查询条件
     */
    genQuery () {
      let query = {}
      query['conditions'] = this.conditions  // 筛选条件
      query['stype'] = this.stype  // 公告类型
      query['ttype'] = this.ttype  // 标题类型
      query['keywords'] = this.delPunctuation(this.keywords)
      query['companyCode'] = this.companyCode   // 公司证券代码
      query['datetype'] = this.datetype    // 日期范围
      query['startdate'] = this.startdate  // 筛选-起始日期
      query['enddate'] = this.enddate    // 筛选-终点日期

      query['keywords_condition'] = this.keywords_condition   // 关键词
      query['perPage'] = this.perPage  // 每页显示条目数
      query['page'] = this.page   // 第几页
      query['sort'] = this.sort   // 排序方式
      query['parseVer'] = this.parseVer
      query['idxname'] = this.idxname
      query['sid'] = this.sid
      query['ruid'] = this.params.uidUrl
      if (this.ai === 1) {
        query['ai'] = 1
      }
      return query
    },
    // 去除标点
    delPunctuation: function (str) {
      let s = str.replace(/[\ |\~|\!|\-|\_|\=|\[|\]|\，|\、|\‘|\’|\；|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g," ")
      return s
    },
    /**
     * 收起下拉框
     * @param  { Object } e 事件对象
     */
    hideDropdown (e) {
      console.log(e)
      let target = $('.slide-menu')
      if (!target.is(e.target) && target.has(e.target).length === 0) {
        $('.slide-menu').css('display', 'none')
        this.showDropdownMenu = ''
      }
    },
    /**
     * 切换显示：搜索条件、搜索结果、统计
     * @param { Number } val - 1:搜索条件 2:搜索结果 3:统计
     */
    switchPage (val) {
      if (this.currentRegtyp === 4) {   // 未绑定微信，提示去绑定
        this.tipGoBind = true
        return
      }
      if (val === 1) {    // 搜索条件
        this.showSearchPage = true
        this.showTongjiPage = false
        this.showResultPage = false
      } else if (val === 2) {   // 搜索结果
        this.showSearchPage = false
        this.showTongjiPage = false
        this.showResultPage = true
      } else if (val === 3) {   // 统计
        this.showSearchPage = false
        this.showTongjiPage = true
        this.showResultPage = false
        if (this.showStatFilter) {
          this.showStatAnalyze = false
        }
      }
    },
    /**
     * 查看表格全部内容
     * @param  { Object } item  搜索结果child数组项
     * @param  { String } tcode id
     * @param  {[type]} offset [description]
     */
    viewTable (item, tcode, offset) {
      if (this.currentRegtyp === 4) {   // 未绑定微信，提示去绑定
        this.tipGoBind = true
        return
      }
       console.log(item,tcode,offset)
       console.log('查看全部表格')
      let _offset = parseInt(offset) + 1
      let _tcode = tcode + '-' + _offset.toString()
      let url = ''
      if (item.viewtype === 1) {
        if (item.pid) {
          url = window.location.origin + '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname
          window.location.href = url
        } else {
          url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname
          window.location.href = url
        }
      } else {
        alert('暂不支持结构化浏览')
      }
    },
    /**
     * 点击章节标题，查看公告详情
     * @param  { Object } item  搜索结果child数组项
     * @param  { String } tcode id
     */
    viewChildTitle (item, tcode) {
      if (this.currentRegtyp === 4) {
        this.tipGoBind = true
        return
      }
      let _tcode = tcode + '-0';
      console.log('点击小标题');
      if (item.viewtype === 1) {
        if (item.pid) {
          var url = '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + '&ccode=' + _tcode + '&idxname=' + this.idxname;
          console.log(url);
          window.location.href = url;
        } else {
          var url = '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + '&ccode=' + _tcode + '&idxname=' + this.idxname;
          console.log(url);
          window.location.href = url;
        }
      } else {
        alert('暂不支持结构化浏览')
      }
    },
    /**
     * click勾选智能引擎多选框
     */
    smartBtn: function () {
      if (this.currentRegtyp == 4) {
        this.tipGoBind = true
        return
      }
      if (this.ai === 1) {
        this.ai = 0
      } else {
        if (!this.checkPrivilege('search/ai', '智能引擎功能火热测试中，暂由VIP用户专享！')) {
          return false
        }
        this.ai = 1
      }
    },
    /**
     * 提取url中指定查询参数
     * @param  { String } name 待提取的查询字符串名
     * @return { Boolean}      查询字符串值 or null
     */
    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    /**
     * 下载App
     */
    downloadApp () {
      // console.log('downloadApp')
      let url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ikw.fse'
      window.open(url)
    },
    backHistory: function () {
      if (window.history.length > 1) {
        if (document.cookie.indexOf('embed=1') >= 0) {
          this.back = true
        }
      }
    },
    /**
     * 显示绑定微信提示框
     */
    showTipGoBind () {
      console.log('showTipGoBind')
      let that = this
      let timer = setTimeout(function () {
        that.tipGoBind = true
        console.log('showTipGoBind')
      }, 5000)
    },
    /**
     * 跳转到绑定页面
     * @param  {[type]} x [description]
     */
    goBindPage (x) {
      console.log('goBindPage')
      if (x) {
        let uri = encodeURIComponent(window.location.href)
        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + uri
      } else {
        let nowUrl = window.location.href
        this.getShortLink(nowUrl)
        let uri = encodeURIComponent(this.goBindPageShortLink)
        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + uri
      }
    },
    /**
     * 生成短链接
     * @param  { String } url 原链接
     * @return { String }     接口返回的短连接
     */
    getShortLink (url) {
      console.log('getshortlink')
      let query = {}
      query.uid = parseInt(this.uid)
      query.url = url
      query.plat = 'mobile'
      query.share = 'weixin'
      query.action = 'SEARCH'
      console.log(query)
      $.ajax({
        url: apiUrl('/V1.0.0/user/sharelink'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query),
        async: false
      }).done((response) => {
        if (response.status === 0) {
          this.goBindPageShortLink = response.url
        } else {
          console.log(response.description)
        }
      }).fail((response) => {
        console.log(response)
      })
    },
    /**
     * 友盟统计
     * @param {[type]} name   [description]
     * @param {[type]} action [description]
     * @param {[type]} label  [description]
     */
    setCnzz (name, action, label) {
      window._czc.push(['_trackEvent', name, action, label])
      console.log(name + ' : ' + action + ' : ' + label)
    },
    /**
     * 替换url中指定查询参数值
     * @param  { String } url 原始链接
     * @param  { String } arg 查看字符串键名
     * @param  { String } val 新的查询字符串值
     * @return { String }     新链接
     */
    changeUrlArg(url, arg, val){
      // console.log('changeUrlArg')
      var pattern = arg+'=([^&]*)'
      var replaceText = arg+'='+val
      return url.match(pattern) ? url.replace(eval('/('+ arg+'=)([^&]*)/gi'), replaceText) : (url.match('[\?]') ? url+'&'+replaceText : url+'?'+replaceText)
    },
    fileIcon (fileext) {
      if (fileext === 'pdf') {
        return 'pdf-icon'
      }
      if (fileext === 'docx' || fileext === 'doc') {
        return 'dov-icon'
      }
      if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
        return 'html-icon'
      }
      if (fileext === 'xls' || fileext === 'xlsx') {
        return 'xsl-icon'
      }
    },
      // 综合搜索
    complex(){
      this.loading = true
        this.stypesArr = [];
        for(let item of this.currentuser.actions){
          if(item == 'search/a'){
            this.stypesArr.push(1)  
          } else if(item == 'search/n3b'){
            this.stypesArr.push(2)
          } else if(item == 'search/bond'){
            this.stypesArr.push(3)
          } else if(item == 'search/weixin'){
            this.stypesArr.push(4)
          } else if(item == 'search/qa'){
            this.stypesArr.push(5)
          } else if(item == 'search/h'){
            this.stypesArr.push(6)
          } else if(item == 'search/report'){
            this.stypesArr.push(11)
          } else if(item == 'search/news'){
            this.stypesArr.push(12)
          } else if(item == 'search/reportdata'){
            this.stypesArr.push(13)
          }
        }
        console.log(this.stypesArr)
        let len = this.stypesArr.length;
        let typ;
        if(len > 0){
          typ = this.stypesArr[len -1 ]
        }
        for(let item of this.stypesArr){
          this.complexSearch(item,typ)
        }
    },
    complexSearch(stype,fag){
      let query = this.genQuery();
      query.stypes = [stype];
      query.perPage = 3;
      $.ajax({
        url: apiUrl('/V1.0.0/notice/searchall'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          if (Object.keys(response.data).length > 0) {
            if (response.data[stype].hasOwnProperty('lists')) {
              if (stype === 5) {
                let items = response.data[stype].lists
                for (let item of items) {
                  if (item.child) {
                    for (let child of item.child) {
                      child.showque = false
                      if (child.answers) {
                        for (let ans of child.answers) {
                          ans.showans = false
                        }
                      }
                    }
                  }
                }
                this[this.stypesMap[stype]] = items
                this.stypesTotal[stype] = response.data[stype].total;
              } else {
                this.stypesTotal[stype] = response.data[stype].total;
                this[this.stypesMap[stype]] = response.data[stype].lists
                console.log(this.stypesTotal)
              }
            }
          } 
          if(this[this.stypesMap[fag]]){
            this.loading  = false;
          }
        }
      })
    },
    // 图片跳转
    viewImg: function (item, tcode, offset) {
      console.log(tcode,offset)
      console.log('查看图片 跳转详情')
      let _offset = parseInt(offset) + 1
      let _tcode = tcode + '-' + _offset.toString()
      if (item.viewtype === 1) {
        if (item.pid) {
          let url = window.location.origin + '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
          window.location.href = url;
        } else {
          let url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
          window.location.href = url;
        }
      } else {
        alert('暂不支持结构化浏览')
      }
    },
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/searchMix.js
 **/